import { BaseEntity } from "yt-ng-framework";

export class Komitent extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null; 
    SNaziv: string = null;
    Pib: string = null;
    MaticniBroj: string = null;
    Adresa: string = null;
    MestoID: number = null;
    Web: string = null;
    VrstaKomitentaID: number = null;
    Napomena: string = null;
    OdgLice: string = null;
    TipKomitentaID: number = null;
    PdvUSistemu: boolean = false;
    PdvBroj: string = null;
    Jmbg: string = null;
    BrojGazdinstva: string = null;
    BrojPoreskogResenja: string = null;
    ImeOca: string = null;
    BrojLicneKarte: string = null;
    Jbkjs: string = null;
    ZaCrf: boolean = false;
    DrzavaID: number = null;
    InoOpis: string = null;
    InoZip: string = null;
    InoPib: string = null;
    InoMesto: string = null;
    Gln: string = null;
    FirmaSifraKodKupca: string = null;
    is_active: boolean = true;

    Deserialize(input: any){
        // super.Deserialize(input);
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;
        this.Web = input.Web;
        this.VrstaKomitentaID = input.VrstaKomitentaID;
        this.Napomena = input.Napomena;
        this.OdgLice = input.OdgLice;
        this.TipKomitentaID = input.TipKomitentaID;
        this.PdvUSistemu = input.PdvUSistemu;
        this.PdvBroj = input.PdvBroj;
        this.Jmbg = input.Jmbg;
        this.BrojGazdinstva = input.BrojGazdinstva;
        this.BrojPoreskogResenja = input.BrojPoreskogResenja;
        this.ImeOca = input.ImeOca;
        this.BrojLicneKarte = input.BrojLicneKarte;       
        this.Jbkjs = input.Jbkjs;
        this.ZaCrf = input.ZaCrf; 
        this.DrzavaID = input.DrzavaID;
        this.InoOpis = input.InoOpis;
        this.InoZip = input.InoZip;
        this.InoPib = input.InoPib;
        this.InoMesto = input.InoMesto;
        this.Gln = input.Gln;
        this.FirmaSifraKodKupca = input.FirmaSifraKodKupca;
        this.is_active = input.is_active;
        return this;
    }

    Serialize(input: Komitent){
        return input;
    }
}
